import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class RestoreRequest extends GenericRequest {

    companyIds;
    workersIds;
    machinesIds;

    constructor(companyIds = [], workersIds = [], machinesIds = []) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.BATCH_RESTORE));

        this.companyIds = companyIds;
        this.workersIds = workersIds;
        this.machinesIds = machinesIds;
    }

    overrideRequest() {
        const request = {};
        request.companies = this.companyIds;
        request.workers = this.workersIds;
        request.machines = this.machinesIds;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/paperbin/ws/RestoreRequest.js